import { TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS, CLEAR_REPAYMENT_HISTORY } from 'redux/actionTypes';

const initialState = {
	cumulativeRepayments: [],
};

// export const locale[];

const RepaymentHistoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_REPAYMENT_HISTORY_API_SUCCESS:
			console.log({
				repaymentHistory: action.data
			})
			return {
				...state,
				...action.data,
				...(!action.data?.dontAppend
					? { cumulativeRepayments: [...state.cumulativeRepayments, ...action.repaymentHistory] }
					: { cumulativeRepayments: [...action.repaymentHistory] }),
			};

		case CLEAR_REPAYMENT_HISTORY:
			return {
				...state,
				cumulativeRepayments: [],
			};
		default:
			return state;
	}
};

export default RepaymentHistoryReducer;
